/**
 * Pauses the execution for the given number of milliseconds.
 * Please do not use this function in production code. It is only for testing purposes like API delays.
 * @param ms Milliseconds to pause the execution
 */
export const sleep = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Checks if the given value is null or undefined.
 * @param value The value to check
 * @returns true if the value is null or undefined, otherwise false
 */
export const isNullOrUndefined = (value: unknown): boolean => value === null || value === undefined;
